angular.module('account.settings')
    .component('accountSettingsProfileComponent', {
        templateUrl: 'app/account/settings/profile.html',
        controller: function ($cookies, toastr, Account, FileUploader) {
            this.$onInit = () => {
                Account.get().$promise.then(data => {
                    this.item = data
                    this.onAvatarChanged(data.avatar)
                })
                Account.groups().$promise.then(result => this.userGroups = result)

                this.uploader = new FileUploader({
                    url: '/crm/api/account/avatar-change',
                    autoUpload: true,
                    headers: {
                        "X-Requested-With": 'XMLHttpRequest',
                        "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                    },
                    onSuccessItem: (fileItem, response, status, headers) => this.onAvatarChanged(true),
                    onErrorItem: (fileItem, response, status, headers) => toastr.error("Błąd wysyłania pliku. Spróbuj ponownie")
                })
            }

            this.onAvatarChanged = (avatar) => {
                this.item.avatar = avatar
                this.renderTime = new Date().getTime()
            }

            this.saveProfile = () => {
                return Account.update(this.item).$promise
                    .then(() => toastr.success("Zapisano"))
                    .catch(fail => toastr.error(fail))
            }

            this.deleteAvatar = () => Account.avatarRemove().$promise.then(() => this.onAvatarChanged(false))
            this.getFullName = () => [this.item.name, this.item.lastname].filter(n => n).join(" ")
        }
    })
